/** Owner-configurable edit/delete windows for task chat messages (minutes). */
export const CHAT_MESSAGE_WINDOW_MIN_MINUTES = 0;
export const CHAT_MESSAGE_WINDOW_MAX_MINUTES = 24 * 60;
export const CHAT_MESSAGE_WINDOW_STEP_MINUTES = 10;

export function clampChatMessageWindowMinutes(minutes: number): number {
  return Math.min(
    CHAT_MESSAGE_WINDOW_MAX_MINUTES,
    Math.max(CHAT_MESSAGE_WINDOW_MIN_MINUTES, Math.round(minutes)),
  );
}

/** Matches `formatChatMessageWindowMinutes` in `chat_message_window.dart`. */
export function formatChatMessageWindowMinutes(minutes: number): string {
  const m = clampChatMessageWindowMinutes(minutes);
  if (m < 60) return `${m} minutes`;
  const h = Math.floor(m / 60);
  const rem = m % 60;
  if (rem === 0) return h === 1 ? '1 hour' : `${h} hours`;
  return `${h}h ${rem}m`;
}
